import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { TabIdGeneratorService } from "./tab-id-generator.service";
import { TabTemplateCacheService } from "./tab-template-cache.service";
import { TabCacheService } from "./tab-cache.service";

@Injectable({
  providedIn: "root",
})
export class ActivatedTabService {
  constructor(
    private router: Router,
    private tabIdGeneratorService: TabIdGeneratorService,
    private tabTemplateCacheService: TabTemplateCacheService,
    private tabCacheService: TabCacheService
  ) {}

  generateNewTabId(): string {
    return this.tabIdGeneratorService.generateNewTabId();
  }

  getTabId(route: ActivatedRouteSnapshot) {
    if (route && route.queryParamMap.has("tabId")) {
      return route.queryParamMap.get("tabId");
    } else if (route && route.data && route.data.tab) {
      return route.data.tab.id;
    } else if (route.firstChild) {
      return this.getTabId(route.firstChild);
    } else {
      return null;
    }
  }

  getTab(route: ActivatedRouteSnapshot) {
    if (route.data && route.data.tab) {
      return route.data.tab;
    } else if (route.firstChild) {
      return this.getTab(route.firstChild);
    } else {
      return null;
    }
  }

  getTabById(tabId) {
    return this.tabCacheService.getTabById(tabId);
  }

  getCachedTemplateByName(tempalteName) {
    return this.tabTemplateCacheService.getTemplateByName(tempalteName);
  }

  getQueryParamMap(state: RouterStateSnapshot) {
    const url = state.url;
    const parsedUrl = this.router.parseUrl(url);
    return parsedUrl.queryParamMap;
  }
}
